module.exports = __webpack_public_path__ + "img/北京古树游览推荐-天坛.de84f1c4.jpg";